import { render, staticRenderFns } from "./MissingPostgresMetrics.vue?vue&type=template&id=5267e960&scoped=true"
import script from "./MissingPostgresMetrics.vue?vue&type=script&lang=js"
export * from "./MissingPostgresMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5267e960",
  null
  
)

export default component.exports